
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_l2os5_94",
  "recovery": "awsui_recovery_vrgzu_l2os5_106"
};
  